import * as yup from "yup";
export const shapeFileSchema = yup.object({
  // files: yup.object().required(),
});
